





















import Vue from 'vue';
import { mapGetters } from 'vuex';
import { cloneDeep, flatten, uniqBy, snakeCase } from 'lodash';
import LoadingSpinner from '@reciprocity/loading-spinner';
import ZenTable from '@/components/listing/ZenTable.vue';
import { keysToSnake, keysToCamel } from '@/utils';
import { getRequest } from '../../../utils/client/client';

export interface HeatmapRiskParams {
  xVectorId: string;
  yVectorId: string;
  xThresholdIndex: number;
  yThresholdIndex: number;
  objectType: string;
  objectId: string;
  statuses: string;
  tags: string;
  scoreId: string;
}

export interface RiskScore {
  title: string;
  score: number;
}

export interface RiskObject {
  title: string;
  id: number;
  url: string;
  riskScores: RiskScore[];
  cellIndex: number;
}

export default Vue.extend({
  name: 'HeatmapListing',
  components: {
    ZenTable,
    LoadingSpinner,
  },
  directives: {},
  props: {
    scores: {
      type: Array,
      default: () => [],
    },
    selectedRiskParams: {
      type: Object as () => HeatmapRiskParams,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      entries: <RiskObject[]>[],
    };
  },
  computed: {
    ...mapGetters(['routes']),
    columns() {
      const columns = [{ key: 'title', presenter: 'RiskTitle' }];
      this.scores.forEach(riskScore => {
        columns.push({ key: snakeCase(riskScore.title), label: riskScore.title, presenter: 'RiskScores' });
      });
      return columns;
    },
  },
  watch: {
    selectedRiskParams: {
      immediate: true,
      deep: true,
      handler: async function(data) {
        if (!data.scoreId || !data.selectedCells.length) {
          this.entries = [];
        } else {
          // Add the ones that weren't selected before:
          let newItems = data.selectedCells.filter(a => !this.entries.some(b => b.cellIndex === a.cellIndex));
          let params = cloneDeep(data);
          delete params.selectedCells;
          let paramses = newItems.map(a => ({
            xThresholdIndex: a.value[0],
            yThresholdIndex: a.value[1],
            cellIndex: a.cellIndex,
            ...params,
          }));
          await this.fetchRisksForItems(paramses);

          // Remove all entries from dictionary that are not selected anymore:
          this.entries = this.entries.filter(a =>
            data.selectedCells.find(b => {
              return b.cellIndex === a.cellIndex;
            })
          );
        }
      },
    },
  },
  methods: {
    async fetchRisksForItems(paramses) {
      let promises = paramses.map(params => {
        try {
          return getRequest({ url: this.routes.riskList, params: keysToSnake(params) });
        } catch (error) {
          throw error;
        }
      });
      this.loading = true;
      let groups = await Promise.all(promises);
      groups = groups.map(data => keysToCamel(data));
      for (let i = 0; i < groups.length; i++) {
        for (let item of groups[i]) {
          item.cellIndex = paramses[i].cellIndex;
        }
      }
      this.entries = this.entries.concat(flatten(groups));
      this.entries = uniqBy(this.entries, a => a.title); // filter duplicates
      this.entries.sort((a, b) => a.cellIndex - b.cellIndex);
      this.loading = false;
    },
  },
});
